import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about',
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  aboutContent = {
    mission: 'Our mission is to provide secure, reliable, and private internet connections to users around the world.',
    vision: 'To create a safe and open internet environment for everyone, free from surveillance and restrictions.',
    values: [
      'Security',
      'Privacy',
      'Transparency',
      'Innovation'
    ],
    team: [
      { name: 'Rifat Tamanna', role: 'CEO', photo: 'assets/images/img_rifat_tamanna.png' },
      { name: 'Rifat Hossain', role: 'Head of Sales/Marketing', photo: 'assets/images/img_rifat_hossain.png' },
      { name: 'Vaskar Singha', role: 'CTO', photo: 'assets/images/img_vaskar_singha.png' }
    ]
  };
}
